import React from 'react';
import { Link } from 'react-router-dom';
import './ISO22301.css';

const ISO22301 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 22301 Societal Security and Business Continuity Management System</h1>
            <h2 className="page-subtitle">Business Continuity Strategy: Guided by ISO 22301</h2>
            <div className="page-text-content">
              <p>
                As NQC (Nova Quality Certification Agency), we proudly present the ISO 22301 Societal 
                Security and Business Continuity Management System to help businesses be resilient against 
                unexpected events and ensure business continuity. In this article, we will delve into what 
                ISO 22301 is, the concept of business continuity management, the advantages it offers to 
                businesses, and how it is implemented in detail.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 22301?</h2>
            <div className="page-text-content">
              <p>
                ISO 22301 is an international standard for business continuity management. This standard 
                provides a framework for organizations to manage crises and emergencies, ensure business 
                continuity, and maintain societal security. ISO 22301 aims for organizations to develop, 
                implement, monitor, and continuously improve their business continuity plans.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Key Elements of ISO 22301:</h2>
            <div className="elements-list">
              <div className="element-item">
                <h3 className="element-title">1. Risk Assessment</h3>
                <p className="element-description">
                  ISO 22301 requires organizations to identify potential risks and take measures against 
                  these risks.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">2. Strategic Planning</h3>
                <p className="element-description">
                  Business continuity strategies are determined, and plans for how to act during crises are 
                  developed.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">3. Emergency Management</h3>
                <p className="element-description">
                  Organizations should be able to effectively communicate and maintain management structures 
                  during emergencies.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">4. Continuous Improvement</h3>
                <p className="element-description">
                  ISO 22301 encourages organizations to adopt continuous improvement principles and 
                  optimize their processes.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Advantages of ISO 22301 for Businesses:</h2>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">1. Resilience to Crises</h3>
                <p className="advantage-description">
                  ISO 22301 makes organizations resilient to unexpected events and enables them to respond 
                  quickly.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">2. Reputation Protection</h3>
                <p className="advantage-description">
                  Business continuity plans preserve the organization's reputation and ensure stakeholder trust.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">3. Operational Continuity</h3>
                <p className="advantage-description">
                  Business continuity management ensures that operations continue smoothly even during 
                  disruptions.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">4. Legal Compliance</h3>
                <p className="advantage-description">
                  ISO 22301 helps businesses comply with legal regulations regarding crisis management and 
                  business continuity.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">5. Customer Satisfaction</h3>
                <p className="advantage-description">
                  ISO 22301 enhances customer satisfaction by increasing the capacity to provide 
                  uninterrupted services.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How to Implement ISO 22301?</h2>
            <div className="page-text-content">
              <p>
                The implementation process of ISO 22301 may vary depending on the size and complexity of the 
                organization. However, the implementation steps can generally be summarized as follows:
              </p>
            </div>
            <div className="steps-list">
              <div className="step-item">
                <h3 className="step-title">1. Initial Assessment</h3>
                <p className="step-description">
                  Existing business continuity management processes are evaluated, and improvement areas are 
                  identified.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">2. Risk Assessment and Planning</h3>
                <p className="step-description">
                  The organization identifies potential risks and creates action plans to mitigate these risks.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">3. Business Continuity Training</h3>
                <p className="step-description">
                  Personnel are trained on business continuity plans and processes.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">4. Documentation and Monitoring</h3>
                <p className="step-description">
                  Documentation is created in line with ISO 22301 requirements, and business continuity 
                  performance is regularly monitored.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">5. Audit and Improvement</h3>
                <p className="step-description">
                  Compliance with ISO 22301 standards is regularly audited, and action plans for continuous 
                  improvement are established.
                </p>
              </div>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO22301;

